module.exports = __webpack_public_path__ + "img/icon_notice.a8cfb2fc.svg";